module.exports = __webpack_public_path__ + "img/office.4942443a.jpeg";